import { ImpactFeedbackStyle, NotificationFeedbackType } from 'expo-haptics';

async function notificationAsync(
  _type: NotificationFeedbackType = NotificationFeedbackType.Success,
): Promise<void> {}

async function impactAsync(
  _type: ImpactFeedbackStyle = ImpactFeedbackStyle.Medium,
): Promise<void> {}

async function selectionAsync(): Promise<void> {}

export { ImpactFeedbackStyle, impactAsync, notificationAsync, selectionAsync };
